import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import PortfolioPageComponent from '../components/portfolio/portfolio-page';
import { CtaBlockType } from '../components/common/cta-block';
import { ProjectsType } from '../components/portfolio/projects';

const PortfolioPageTemplateWrapper = ({ data: { pageConfig: { title, topCtaBlock, bottomCtaBlock, projects } } }) => (
  <PortfolioPageComponent topCtaBlock={topCtaBlock} bottomCtaBlock={bottomCtaBlock} projects={projects}>
    <Helmet title={title} />
  </PortfolioPageComponent>
);
PortfolioPageTemplateWrapper.propTypes = {
  data: PropTypes.shape({
    pageConfig: PropTypes.shape({
      title: PropTypes.string,
      topCtaBlock: CtaBlockType,
      bottomCtaBlock: CtaBlockType,
      projects: ProjectsType,
    }).isRequired,
  }).isRequired,
};
export default PortfolioPageTemplateWrapper;

export const pageQuery = graphql`
  query PortfolioPageQuery($path: String!) {
    pageConfig: pagesYaml(path: { eq: $path }) {
      id
      title
      topCtaBlock {
        hasImage
        isDark
        hasButton
        image
        headText
        subText
        linkText
        linkUrl
      }
      bottomCtaBlock {
        hasImage
        isDark
        hasButton
        image
        headText
        subText
        linkText
        linkUrl
      }
      projects {
        items {
          name
          description
          linkText
          linkUrl
          backgroundColor
          hasButton
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/portfolio-page.jsx